/* eslint-disable import/no-unused-modules */
import React, { memo } from 'react';
import PropTypes from 'prop-types';

import {
  Tabs as TabsCommons,
  Tab,
  Box,
  styled,
} from '@datanomik/commons-ui';

import { a11yProps } from './utils';

import { TabPanel } from './TabPanel';

import useTabs from './hooks';

export const StaticTabsRaw = memo(({
  className, items, initialValue = 0, keepMounted,
}) => {
  const { value, handleChange } = useTabs({ initialValue, items });

  const boxClasses = {
    [className]: true,
  };

  return (
    <Box className={boxClasses}>
      <Box>
        <TabsCommons
          value={value}
          onChange={handleChange}
          aria-label=""
          variant="scrollable"
          scrollButtons="auto"
        >
          {items.map(({
            id, label, icon, labelEnd,
          }, index) => (
            <Tab
              key={`tab-${label}-${id}`}
              labelEnd={labelEnd}
              endAdornment={icon}
              iconPosition="start"
              component={Box}
              sx={{
                flex: '0 0 auto',
              }}
              {...a11yProps(index)}
            >
              {label}
            </Tab>
          ))}
        </TabsCommons>
      </Box>
      {items.map(({ component, id: tabPanelIndex }, index) => (
        <TabPanel key={`tab-panel-${tabPanelIndex}`} value={value} index={index} keepMounted={keepMounted}>
          {component}
        </TabPanel>
      ))}
    </Box>
  );
});

StaticTabsRaw.propTypes = {
  className: PropTypes.string,
  keepMounted: PropTypes.bool,
  items: PropTypes.array.isRequired,
};

export const StaticTabs = styled(StaticTabsRaw)({});

StaticTabs.propTypes = StaticTabsRaw.propTypes;
